import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { StyleSheet } from 'react-native';
import { BodyText, Button, theme } from '@sg/garnish';

import { BUTTON_HEIGHT } from '../../upsell.constants';

// ─────────────────────────────────────────────────────────────────────────────

export const UpsellCloseButton = (props: UpsellCloseButtonProps) => {
  const { onPress, disabled } = props;

  return (
    <Button
      onPress={onPress}
      disabled={disabled}
      style={styles.button}
      size="large"
      palette="kaleLightest"
    >
      <BodyText
        sizeMatch={['18']}
        style={disabled ? styles.disabledText : styles.buttonText}
      >
        <FormattedMessage {...messages.close} />
      </BodyText>
    </Button>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  close: {
    defaultMessage: 'Back to menu',
    description: 'Upsell modal | Close button | Text',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  button: {
    height: BUTTON_HEIGHT,
    paddingHorizontal: theme.spacing['8'],
  },
  buttonText: {
    color: theme.colors.KALE,
  },
  disabledText: {
    color: theme.colors.OPACITY.KALE.LIGHT,
  },
});

// ─────────────────────────────────────────────────────────────────────────────

type UpsellCloseButtonProps = {
  onPress: () => void;
  disabled?: boolean;
};
